import { z } from 'zod';
import { NativeMessageSchema } from './NativeMessage';

export const DeepLinkMessageSchema = z
  .object({
    type: z.literal('deeplink'),
    url: z.string(),
  })
  .extend(NativeMessageSchema.shape);

export type DeepLinkMessage = z.infer<typeof DeepLinkMessageSchema>;
